import { Link } from "react-router-dom";
import { useEffect } from "react";
import '../Styles/SignUpSignIn.scss';
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Session from 'react-session-api';
import ForgotPassword from "../Components/ForgotPassword";
import BrrCircleLogo from "../Images/BillRiceRanchCircleLogoBlack.png";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";


const SignUpSignIn = () => {

   const navigate = useNavigate();
   const [state, setState] = useState({
      username: '',
      password: ''
   })

   const [error, setError] = useState(false)

   const [isGroupSignIn, setIsGroupSignIn] = useState(false);
   const [showForgotPassword, setShowForgotPassword] = useState(false);
   const [showPassword, setShowPassword] = useState(false);
   // The sign-in request can lag for a few seconds with nothing on screen to show it's working —
   // this is what lets the button reflect that instead of looking stalled.
   const [isSigningIn, setIsSigningIn] = useState(false);


   const handleSubmit = async (event) => {
      event.preventDefault()
      setIsSigningIn(true)
      try {

         if (Session.get("isAuth") === "true") {
            console.log("True")
            alert("You are already logged in. Please log out if you would like to log into a different account")
         }
         else {

            // ✅ Use different endpoint depending on sign-in type. You will need to change API/group-login. That isn't a real endpoint.
            const endpoint = isGroupSignIn ? '/api/grouplogin' : '/api/login';

            const apiResponse = await fetch(endpoint, {
               method: 'POST',
               headers: { "Content-Type": "application/json" },
               body: JSON.stringify({
                  email: state.username,
                  password: state.password
               })
            })

            let loginResult;
            try {
               loginResult = await apiResponse.json();
            } catch (jsonErr) {
               setError("Unexpected server response. Please try again.");
               return;
            }
            console.log("login Result", loginResult);

            if (apiResponse.status === 400 || apiResponse.status === 500) {
               const errorMsg = loginResult?.errors?.[0]?.msg || "Login failed. Please try again.";
               throw new Error(errorMsg);
            }

            Session.set("isAuth", apiResponse.ok.toString())
            Session.set("accountType", isGroupSignIn ? "group" : "individual");


            navigate(isGroupSignIn ? '/groupaccount' : '/individualaccount');
         }

      }

      catch (err) {
         setError(err.message)
         console.error(err.message);
      }
      finally {
         setIsSigningIn(false)
      }

   }

   return (
      <div className="AccountTypeSelectionContent">
         <div className="AccountTypeSelectionContainer">
            <div className="AccountTypeSelectionHeading">
               <img src={BrrCircleLogo} alt="Bill Rice Ranch" className="accountTypeSelectionLogo" />
               <div>
                  Bill Rice Ranch
               </div>
               <div>
                  Online Registration
               </div>
            </div>
            <div className="signUpSignIn">

               <div className="accountSignIn">
                  <div className="accountSignInLabel">
                     Sign In To Register For Camp
                  </div>
                  {isGroupSignIn && (
                     <div className="groupSignInBanner">
                        <div className="groupSignInMessage">
                           You are signing in to a <strong>church group account</strong>.
                        </div>
                        <span
                           className="dismissGroupSignIn"
                           onClick={() => setIsGroupSignIn(false)}
                           style={{ marginLeft: '10px', cursor: 'pointer', color: '#0077cc' }}
                        >
                           <small>
                              Switch to individual
                           </small>
                        </span>
                     </div>
                  )}

                  <form>
                     <div className="accountInfo">

                        <div className="accountUserName">
                           <label for="lastName">Email Address</label>
                           <input id="lastName"
                              type="text"
                              name="groupAdminName"
                              onChange={(event) => (setState({ ...state, username: event.target.value }))}
                           />
                        </div>
                        <div className="accountPassword">
                           <label for="groupPassword">Password</label>
                           <div className="accountSignInPasswordWrapper">
                              <input
                                 id="email"
                                 type={showPassword ? "text" : "password"}
                                 name="groupPassword"
                                 onChange={(event) => (setState({ ...state, password: event.target.value }))}
                              />
                              <button
                                 type="button"
                                 className="accountSignInPasswordToggle"
                                 onClick={() => setShowPassword(!showPassword)}
                                 aria-label={showPassword ? "Hide password" : "Show password"}>
                                 {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                              </button>
                           </div>
                        </div>
                        <div>
                           <label>{error}</label>
                        </div>
                     </div>
                  </form>
                  <div className="accountSignInButton">
                     <button className="signInButton" disabled={isSigningIn} onClick={(event) => (handleSubmit(event))}>
                        {isSigningIn && <span className="authSpinner" aria-hidden="true"></span>}
                        {isSigningIn ? "Signing In..." : "Sign In"}
                     </button>
                  </div>
               </div>
               <div className="AccountSignUp">
                  <div className="AccountSignUpLabel">
                     {isGroupSignIn ? "Don't have a church group account?" : "Don't have an account?"}
                  </div>
                  {/* <div className="AccountSignUpIndividualRegistration">
                     <Link to={isGroupSignIn ? "/creategroupaccount" : "/createIndividualAccount"}>
                        Sign up
                     </Link>
                  </div> */}
                  <div className="AccountSignUpIndividualRegistration">
                        <Link to="/createindividualaccount">
                           Sign up
                        </Link>
                  </div>

                  {/* <div className="AccountSignUpIndividualRegistration">
                     {isGroupSignIn ? (
                        <Link to="/creategroupaccount">
                           Sign up
                        </Link>
                     ) : (
                        <div className="individualUnavailableMessage">
                           <div className="individualUnavailableHeading">
                              Individual Registration Coming November 22, 2025
                           </div>
                        </div>
                     )}
                  </div> */}

                  {!isGroupSignIn && (<hr></hr>)}
                  <div className="groupSignUpInfo">
                     {!isGroupSignIn && (
                        <div>
                           <div className="groupToggleLink">
                              <div className="accountSignUpLabel">
                                 <small>
                                    Need to make a group reservation for your church?
                                 </small>
                                 {/* <small>
                                    Group reservations are currently closed for maintenance and will be available soon. <br></br>
                                    For questions, please contact registration@billriceranch.org.
                                 </small> */}
                              </div>
                              <div className="groupAccountSignInButton">
                                 <span
                                    onClick={() => setIsGroupSignIn(true)}
                                    style={{ color: "#0077cc", cursor: "pointer", textDecoration: "underline" }}
                                 >
                                    <small>
                                       Sign in to a church group account
                                    </small>
                                 </span>
                              </div>
                           </div>
                           <div className="accountSignUpGroupRegistration">
                              <div>
                                 <small>
                                    <Link to={"/creategroupaccount"} style={{ color: "#0077cc", textDecoration: "underline" }}>
                                       Create a church group account
                                    </Link>
                                 </small>
                              </div>
                           </div>
                        </div>
                     )}
                  </div>
                  <div className="forgotPasswordButtonSection">
                     <button className="forgotPasswordButton" onClick={() => setShowForgotPassword(!showForgotPassword)}>
                        Forgot Password?
                     </button>
                  </div>
                  <div className="forgotPasswordSection">
                     <ForgotPassword
                        show={showForgotPassword}
                     />
                  </div>
                  {/* <div className="accountSignUpLabel">
                     Register Groups For Camp
                     </div>
                     <div className="groupRegistration">
                        <Link to={'/groupsignup'}>
                           <button>
                              Create Group Account
                           </button>
                        </Link>
                     </div> */}
               </div>
            </div>


         </div>
      </div>
   )
}
export default SignUpSignIn;
